import TopBarProgress from "react-topbar-progress-indicator";
TopBarProgress.config({
  barThickness: 1,
  shadowBlur: 5,
});
export default TopBarProgress;
